// extracted by mini-css-extract-plugin
export var deleteIcon = "_tm-5";
export var deleteOption = "_tm-3";
export var divider = "_tm-2";
export var downloadIcon = "_tm-4";
export var drawer = "_tm-0";
export var drawerFooter = "_tm-6";
export var drawerOpen = "_tm-1";
export var highlighted = "_tm-7";
export var lighterHighlight = "_tm-8";